// extracted by mini-css-extract-plugin
export var container = "_m0-0";
export var dotAnimation = "_m0-2";
export var dotsLoading = "_m0-1";